import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconExpandVerticalStyle0 = gravityIconIndividualCss;

const GravityIconExpandVertical = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '35d520aa121d8e444042247be2c29726e064c4dd', color: this.color, size: this.size }, h("svg", { key: '9e9a7c56942e2532b5b6b563319eb0debe8d319f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '98f639133a31c68884e297e153eb098a2059a777', d: "M13.482 7c.444 0 .682-.541.389-.887l-2.482-2.93a.507.507 0 0 0-.778 0l-2.482 2.93c-.293.346-.055.887.39.887h4.963ZM3 10.75a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-.5Zm5.129 5.137c-.293-.346-.055-.887.39-.887h4.963c.444 0 .682.541.389.887l-2.482 2.93a.506.506 0 0 1-.778 0l-2.482-2.93Z", fill: "currentColor" }))));
    }
};
GravityIconExpandVertical.style = GravityIconExpandVerticalStyle0;

export { GravityIconExpandVertical as gravity_icon_expand_vertical };

//# sourceMappingURL=gravity-icon-expand-vertical.entry.js.map